import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import info from '../../../../assets/global/info.png';
import NoBrandFound from '../../../../assets/images/NoBrandFound.png';
import searchNotFound from '../../../../assets/images/searchNotFound.png';
import BrandLoaderCard from './brandLoaderCard';
import { matchBrand, useRenderData } from '../../brands.utils';
import { useAllOffers } from '../../../../api/api.calls';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { viewportToPixels } from '../../../../utils/common.utils';
import UrlNotFound from '../UrlNotFound';
import { useIdHash, useNavigateRoute } from '../../../../hooks/custom.hooks';
import store from '../../../../assets/global/store.png';
import CustomImg from '../../../../components/CustomImg/index';

function AllBrand({ searchedValue, setSearchedValue, brand }) {
  const { isLoading } = useAllOffers();
  const { selected = [] } = useIdHash();
  const { categories, renderData, availableCategories } = useRenderData(
    brand || {},
  );
  const [filteredData, setFilteredData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const hasNonEmptyArray = useMemo(
    () => Object.keys(brand || {}).some((key) => (brand[key] || []).length > 0),
    [brand],
  );
  useEffect(() => {
    if (!brand || !selected) return;
    const matchIds = selected?.split(',');
    const filterMerchants = (brands) => {
      return brands.filter((merchant) =>
        matchIds.includes(merchant.merchant_id.toString()),
      );
    };
    const filteredData = {
      'Preferred Brands': filterMerchants(renderData['Preferred Brands']),
      'More Brands': filterMerchants(renderData['More Brands']),
    };
    setSelectedData(filteredData);
  }, [selected, brand, renderData]);
  useEffect(() => {
    if (!searchedValue) {
      return;
    }
    const result = Object.values(brand)
      .flatMap((array) =>
        array
          .filter((item) => item.merchant_name)
          .map((item) => {
            const match = matchBrand(item.merchant_name, searchedValue);
            return match ? { ...item, ...match } : null;
          }),
      )
      .filter(Boolean)
      .reduce((acc, item) => {
        if (
          !acc[item.merchant_name] ||
          parseInt(item.merchant_rank) <
            parseInt(acc[item.merchant_name].merchant_rank)
        ) {
          acc[item.merchant_name] = item;
        }
        return acc;
      }, {});

    const sortedResult = Object.values(result).sort((a, b) => {
      if (b.matchRank !== a.matchRank) {
        return b.matchRank - a.matchRank; // Higher matchRank first
      }
      return parseInt(a.merchant_rank) - parseInt(b.merchant_rank); // Lower rank first
    });

    setFilteredData(sortedResult);
  }, [brand, searchedValue]);

  const navigateRoute = useNavigateRoute();

  const handleClick = (brand) => {
    if (brand.merchant_id) {
      navigateRoute({
        nextPage: `/offers?brand=${brand.merchant_id}`,
      });
    } else {
      setOpen(true);
    }
  };

  if (isLoading) {
    return (
      <div className={styles.offersListWrapper}>
        <BrandLoaderCard category={categories} />
      </div>
    );
  }

  const NotAvailableData = () => {
    return (
      <div className={styles.notFound}>
        <CustomImg
          fallbackSrc={store}
          src={searchNotFound}
          alt="noResults"
          className={styles.notFoundImg}
        />
        <div className={styles.textRow}>
          <CustomImg fallbackSrc={info} src={info} alt="info" />
          <div>No Results Found</div>
        </div>
        <div
          className={styles.clearFilters}
          onClick={() => {
            setSearchedValue('');
          }}
        >
          Search a different brand
        </div>
      </div>
    );
  };

  const ClearSearchedValue = () => {
    return (
      <div className={styles.showingFiltered}>
        <div className={styles.left}>Showing results</div>
        <div className={styles.clear} onClick={() => setSearchedValue('')}>
          CLEAR
        </div>
      </div>
    );
  };
  const BrandList = ({ data }) => {
    return (
      <>
        <div className={styles.brandList}>
          {data?.map((brand, brandIndex) => (
            <div
              key={brandIndex}
              className={styles.brandItem}
              onClick={() => handleClick(brand)}
            >
              <CustomImg
                src={brand.merchant_logo}
                alt={brand.merchant_name}
                className={styles.brandLogo}
                fallbackSrc={store}
              />
              <div>{brand.merchant_name}</div>
            </div>
          ))}
        </div>
      </>
    );
  };
  return (
    <>
      {hasNonEmptyArray ? (
        <div className={styles.main}>
          {searchedValue.length === 0 &&
            availableCategories.map((category, index) => (
              <div key={index} className={styles.brandCard}>
                <div className={styles.categoryName}>
                  <span>{category}</span>
                  <div className={styles.underline}></div>
                </div>
                {selected
                  ? selectedData[category]?.length > 0 && (
                      <BrandList data={selectedData[category]} />
                    )
                  : renderData[category]?.length > 0 && (
                      <BrandList data={renderData[category]} />
                    )}
              </div>
            ))}
          {searchedValue.length > 0 && (
            <>
              {filteredData.length > 0 ? (
                <>
                  <ClearSearchedValue />
                  {filteredData.length > 0 && <BrandList data={filteredData} />}
                </>
              ) : (
                <NotAvailableData />
              )}
            </>
          )}
          <BottomSheet
            open={open}
            onDismiss={() => setOpen(false)}
            header={false}
            initialFocusRef={false}
            maxHeight={viewportToPixels('50vh')}
            style={{
              overflow: 'hidden',
            }}
          >
            <UrlNotFound setOpen={setOpen} />
          </BottomSheet>
        </div>
      ) : (
        <div className={styles.notFound}>
          <img
            src={NoBrandFound}
            alt="noResults"
            className={styles.notFoundImg}
          />
          <div className={styles.textRow}>
            <img src={info} alt="info" />
            <div>No Brands Found</div>
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(AllBrand);
